module.exports = __webpack_public_path__ + "img/navigation.b15ca361.svg";